export default "/fonts/Acrom-Light.woff?38ad5d6723234ba4e8c1426cc6a03b68";